import { Box, styled } from '@mui/material';
import { BenefitsStatusIcon } from '../BenefitsStatusIcon';
import { proAccountThemeCoreUI as theme } from '../themes';

/**
 * Props for configuring a card footer overlay component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {string} status - The status of the benefits.
 * @property {string} [footerText] - The text to display in the footer.
 */
export type CardFooterOverlayProps = {
  status: 'Commissioned' | 'Commissionable' | 'Promo' | undefined;
  footerText?: string;
};

const cardWidth = '330px';
const darkBlue = '#011148';

const InvertedBorderBoxContainer = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: cardWidth,
});

const CommonStyles = {
  content: '""',
  position: 'absolute',
  top: '-45px',
  height: '40px',
  width: '15px',
  boxShadow: `0 25px 0 0 ${darkBlue}`,
};

const InvertedBorderBox = styled(Box)({
  position: 'relative',
  width: cardWidth,
  height: '0px',
  top: '-40px',
  '&::before': {
    ...CommonStyles,
    left: 0,
    borderBottomLeftRadius: '25px',
  },
  '&::after': {
    ...CommonStyles,
    right: 0,
    borderBottomRightRadius: '25px',
  },
});

const FooterOverlayContainer = styled(Box)(() => ({
  alignItems: 'center',
  bottom: 0,
  display: 'flex',
  position: 'absolute',
  width: '100%',
  gap: '5px',
  justifyContent: 'flex-start',
  paddingLeft: theme.spacing(2),
  background: darkBlue,
  height: '45px',
  overflow: 'hidden',
}));

export const CardFooterOverlay = (props: CardFooterOverlayProps) => {
  const { status, footerText } = props;

  return (
    <>
      <InvertedBorderBoxContainer>
        <InvertedBorderBox />
      </InvertedBorderBoxContainer>
      <FooterOverlayContainer data-testid="app-card-footer-overlay">
        {footerText && (
          <BenefitsStatusIcon
            status={status}
            label={footerText}
            labelProps={{
              sx: {
                fontSize: '11px',
                fontWeight: '500',
                color: theme.palette.common.white,
                backgroundColor: 'inherit',
                letterSpacing: '2px',
              },
            }}
          />
        )}
      </FooterOverlayContainer>
    </>
  );
};
